import { render, staticRenderFns } from "./NotasExamens.vue?vue&type=template&id=1a77a27d&scoped=true&"
import script from "./NotasExamens.vue?vue&type=script&lang=js&"
export * from "./NotasExamens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77a27d",
  null
  
)

export default component.exports